import { env } from '../../globals/config/env';

export type LogConfig = {
  LOG_CONNECTION_STRING: string | null;
};

export const LOG_CONFIG: LogConfig = {
  LOG_CONNECTION_STRING: env('LOG_CONNECTION_STRING', null),
};
